import FilterService from '@/services/artwork/FilterService'
import FileService from '@/services/file/FileService'
import ArtworkService from '@/services/artwork/ArtworkService'

export default {
  namespaced: true,
  state: {
    currentFilterList: [],
    currentFilter: null,
    currentArtworkId: 0,
    currentArtwork: null,
    currentFilterTotal: 0,
    currentFilterPosition: 0,
    uploadSessionGuid: null,
    isAnyChange: false
  },
  getters: {
    currentFilterList: state => state.currentFilterList,
    currentFilter: state => state.currentFilter,
    currentArtworkId: state => state.currentArtworkId,
    currentArtwork: state => state.currentArtwork,
    currentFilterTotal: state => state.currentFilterTotal,
    currentFilterPosition: state => state.currentFilterPosition,
    uploadSessionGuid: state => state.uploadSessionGuid,
    isAnyChange: state => state.isAnyChange
  },
  actions: {
    filterArtworkList ({ state, commit, rootGetters }) {
      return FilterService.getAll(state.currentFilter)
        .then(list => {
          for (let i = 0; i < list.length; i++) {
            list[i].isInExportBox = !!(rootGetters['exportBoxes/currentBoxContentIds'].has(list[i].id))
          }
          commit('SET_CURRENT_FILTER_LIST', list)
        })
    },
    queryArtwork ({ state, commit, rootGetters }, artworkId) {
      if (artworkId === 0) {
        return
      }

      return ArtworkService.getArtwork(artworkId)
        .then(result => {
          result.isInExportBox = !!(rootGetters['exportBoxes/currentBoxContentIds'].has(state.currentArtworkId))
          commit('SET_CURRENT_ARTWORK_ID', result.artworkId)
          commit('SET_CURRENT_FILTER_POSITION', 0)
          commit('SET_CURRENT_FILTER_TOTAL', 1)
          commit('SET_CURRENT_ARTWORK', result)
          commit('SET_IS_ANY_CHANGE', false)
        })
    },
    queryCurrentArtwork ({ state, commit }) {
      if (state.currentArtworkId === 0) {
        commit('SET_CURRENT_ARTWORK_ID', 0)
        commit('SET_CURRENT_FILTER_POSITION', 0)
        commit('SET_CURRENT_FILTER_TOTAL', 1)
        return
      }

      return FilterService.queryCurrentArtwork(state.currentArtworkId, state.currentFilter)
        .then(result => {
          commit('SET_CURRENT_ARTWORK_ID', result.artworkId)
          commit('SET_CURRENT_FILTER_POSITION', result.position)
          commit('SET_CURRENT_FILTER_TOTAL', result.total)
        })
    },
    queryPreviousArtwork ({ state, commit }) {
      return FilterService.queryPreviousArtwork(state.currentArtworkId, state.currentFilter)
        .then(result => {
          commit('SET_CURRENT_ARTWORK_ID', result.artworkId)
          commit('SET_CURRENT_FILTER_POSITION', result.position)
          commit('SET_CURRENT_FILTER_TOTAL', result.total)
        })
    },
    queryNextArtwork ({ state, commit }) {
      return FilterService.queryNextArtwork(state.currentArtworkId, state.currentFilter)
        .then(result => {
          commit('SET_CURRENT_ARTWORK_ID', result.artworkId)
          commit('SET_CURRENT_FILTER_POSITION', result.position)
          commit('SET_CURRENT_FILTER_TOTAL', result.total)
        })
    },
    getCurrentArtworkData ({ state, commit, rootGetters }) {
      if (state.currentArtworkId === 0) {
        // TODO: class?
        var newArtwork = {
          id: 0,
          type: null,
          name: '',
          thumbnailFileId: -1,
          prices: [],
          techniques: [],
          photos: [],
          attachments: [],
          dimensions: [],
          isInExportBox: null
        }

        commit('SET_CURRENT_ARTWORK', newArtwork)
        commit('SET_IS_ANY_CHANGE', false)

        return
      }

      return ArtworkService.getArtwork(state.currentArtworkId)
        .then(result => {
          result.isInExportBox = !!(rootGetters['exportBoxes/currentBoxContentIds'].has(state.currentArtworkId))
          commit('SET_CURRENT_ARTWORK', result)
          commit('SET_IS_ANY_CHANGE', false)
        })
    },
    saveCurrentArtworkData ({ state, commit }) {
      state.currentArtwork.uploadSession = state.uploadSessionGuid

      // quick REST validation error fix some vuetify component instead of null gives empty string which cant be parsed
      if (state.currentArtwork.acquisitionsYear === '') {
        state.currentArtwork.acquisitionsYear = null
      }

      if (state.currentArtwork.datingYear === '') {
        state.currentArtwork.datingYear = null
      }

      if (state.currentArtwork.datingYearTo === '') {
        state.currentArtwork.datingYearTo = null
      }

      if (state.currentArtwork.datingYearFrom === '') {
        state.currentArtwork.datingYearFrom = null
      }

      return ArtworkService.saveArtwork(state.currentArtwork).then(_ => {
        commit('SET_UPLOAD_SESSION_GUID', null)
      }).then(_ => {
        commit('SET_IS_ANY_CHANGE', false)
      })
    },
    deleteArtwork ({ commit }, artwork) {
      return ArtworkService.deleteArtwork(artwork).then(_ => {
        commit('DELETE_ARTWORK', artwork)
      })
    },
    updateFilterItems ({ state }) {
      if (state.currentArtwork === null || state.currentFilterlist === null) {
        return
      };

      state.currentFilterList.forEach(item => {
        if (item.id === state.currentArtwork.id) {
          item.name = state.currentArtwork.name
          item.evidenceNumber = state.currentArtwork.evidenceNumber
          item.authors = state.currentArtwork.authors
          item.themes = state.currentArtwork.themes

          var coverPhoto = state.currentArtwork.photos.find(p => p.isCoverPhoto)
          var thumbnailFileId = -1

          if (coverPhoto != null) {
            thumbnailFileId = coverPhoto.thumbnailFileId
          }

          if (item.thumbnailFileId !== thumbnailFileId) {
            item.thumbnailFileId = thumbnailFileId
          }
        }
      })
    },
    async createUploadSession ({ state, commit }) {
      if (state.uploadSessionGuid != null) {
        return
      }

      await FileService.createUploadSession().then(result => {
        commit('SET_UPLOAD_SESSION_GUID', result)
      })
    },
    uploadImage ({ state }, image) {
      if (state.uploadSessionGuid == null) {
        console.log('cannot upload')
        return
      }

      FileService.uploadImage(state.uploadSessionGuid, image).then(photo => {
        state.currentArtwork.photos.push(photo)
      })
    },
    uploadAttachment ({ state }, file) {
      if (state.uploadSessionGuid == null) {
        console.log('cannot upload')
        var reason = 'cannot upload, upload session is null'
        return Promise.reject(reason)
      }

      return FileService.uploadAttachment(state.uploadSessionGuid, file).then(attachment => {
        state.currentArtwork.attachments.push(attachment)
      })
    },
    cleanupUploadSession ({ state, commit }) {
      if (state.uploadSessionGuid == null) {
        return
      }

      FileService.cleanupUploadSession(state.uploadSessionGuid).then(_ => {
        commit('SET_UPLOAD_SESSION_GUID', null)
      })
    },
    clearUploadSession ({ commit }) {
      commit('SET_UPLOAD_SESSION_GUID', null)
    }
  },
  mutations: {
    SET_UPLOAD_SESSION_GUID (state, guid) {
      state.uploadSessionGuid = guid
    },
    SET_CURRENT_FILTER_LIST (state, list) {
      state.currentFilterList = list
    },
    SET_CURRENT_FILTER (state, filter) {
      state.currentFilter = filter
    },
    SET_CURRENT_ARTWORK_ID (state, artworkId) {
      state.currentArtworkId = artworkId
    },
    SET_CURRENT_ARTWORK (state, artwork) {
      state.currentArtwork = artwork
    },
    SET_CURRENT_FILTER_POSITION (state, position) {
      state.currentFilterPosition = position
    },
    SET_CURRENT_FILTER_TOTAL (state, total) {
      state.currentFilterTotal = total
    },
    SET_IS_ANY_CHANGE (state, value) {
      state.isAnyChange = value
    },
    DELETE_ARTWORK (state, artwork) {
      var index = state.currentFilterList.indexOf(artwork)

      state.currentFilterList.splice(index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/artwork/artworks.js